import { Component, computed, ElementRef, Signal, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@core/core.module';

import { MenuComponent } from '../menu/menu.component';
import { LayoutService } from '../../service/layout.service';
import { ConviviaLogoComponent } from '../convivia-logo/convivia-logo.component';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, CoreModule, MenuComponent, RouterModule, ConviviaLogoComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  public menuContainer: Signal<ElementRef | undefined> = viewChild<ElementRef>('menuContainer');

  protected isInactive: Signal<boolean> = computed(() => this.layoutService.layoutState().sidebarActive);
  protected isReveal: Signal<boolean> = computed(() => this.layoutService.layoutConfig().menuMode === 'reveal');
  protected isMobile: Signal<boolean> = computed(() => this.layoutService.isMobile());

  protected containerClass: Signal<Record<string, boolean>> = computed(() => {
    const layoutConfig = this.layoutService.layoutConfig();
    const layoutState = this.layoutService.layoutState();

    return {
      overlay: layoutConfig.menuMode === 'overlay',
      static: layoutConfig.menuMode === 'static',
      reveal: layoutConfig.menuMode === 'reveal',
      'overlay-active': layoutState.overlayMenuActive || layoutState.staticMenuMobileActive,
      'mobile-active': layoutState.staticMenuMobileActive,
      'static-inactive': layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
      'sidebar-active': layoutState.sidebarActive,
      'sidebar-anchored': layoutState.anchored,
    };
  });

  private timeout: NodeJS.Timeout | null = null;

  constructor(private readonly layoutService: LayoutService) {}

  protected onMouseEnter(): void {
    if (!this.layoutService.layoutState().anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.layoutService.layoutState.update(state => {
        if (!state.sidebarActive) {
          return {
            ...state,
            sidebarActive: true,
          };
        }
        return state;
      });
    }
  }

  protected onMouseLeave(): void {
    if (!this.layoutService.layoutState().anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.layoutService.layoutState.update(state => {
            if (state.sidebarActive) {
              return {
                ...state,
                sidebarActive: false,
              };
            }
            return state;
          });

          if (this.layoutService.isReveal()) {
            this.layoutService.reset();
          }
        }, 300);
      }
    }
  }

  protected anchor(): void {
    this.layoutService.layoutState.update(state => ({
      ...state,
      anchored: !state.anchored,
    }));
  }
}
